/**
 * Promise-based wrapper around the browser Geolocation API.
 *
 * Resolves with the current {@link GeolocationPosition} or rejects when geolocation is
 * unavailable or permission is denied.
 */
export function getCurrentPosition(options: PositionOptions = {}): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
    } else {
      reject(new Error('Geolocation is not supported by this browser'))
    }
  })
}
